import { gql } from '@apollo/client'
import { Categories } from './fragments'

export default function getExhibitorCategories() {
  return gql(`
    ${Categories}
    query QueryExhibitorCategories {
      ConferenceDataViewModel {
        exhibitorCategories {
          ...Categories
        }
      }
    }
  `)
}
